import { render, staticRenderFns } from "./DriverDashboard.vue?vue&type=template&id=4fc60a24&"
import script from "./DriverDashboard.vue?vue&type=script&lang=js&"
export * from "./DriverDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports